import { batchActions } from 'redux-batched-actions';
import { closeModalDialog, openModalDialog } from '@nextiva/crm-modals';
import { hideRichTextSelectionHighlightAction } from '@nextiva/rich-text-editor';

import richTextEditorModalsTypes from '../config/richTextEditorModalsTypes';

export const openInsertImageIntoEditorModal = editorId =>
  openModalDialog({
    type: richTextEditorModalsTypes.insertImageIntoEditor,
    editorId,
  });

export const openInsertVideoIntoEditorModal = editorId =>
  openModalDialog({
    type: richTextEditorModalsTypes.insertVideoIntoEditor,
    editorId,
  });

export const openInsertLinkIntoEditorModal = (editorId, { url, label }) =>
  openModalDialog({
    type: richTextEditorModalsTypes.insertLinkIntoEditor,
    editorId,
    label,
    url,
  });

export const openInsertImageLinkIntoEditorModal = (editorId, url) =>
  openModalDialog({
    type: richTextEditorModalsTypes.insertImageLinkIntoEditor,
    editorId,
    url,
  });

export const openCustomLineHeightModal = (
  editorId,
  currentLineHeight,
  currentBlockSpacing,
) =>
  openModalDialog({
    type: richTextEditorModalsTypes.textEditorCustomLineHeight,
    editorId,
    currentLineHeight,
    currentBlockSpacing,
  });

export const closeModalWithRemoveSelectionHighlight = (dialogId, editorId) =>
  batchActions([
    hideRichTextSelectionHighlightAction(editorId),
    closeModalDialog(dialogId),
  ]);
